import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

const supportLink =
  'https://wwwpwcnetwork.pwc.myshn.net/hub?id=sc_cat_item&sys_id=ff2977811b357010bdec7bb5464bcb0f';

const SupportTicketLink = (props) => {
  const { children, className } = props;
  const { t } = useTranslation();
  return (
    <a
      href={supportLink}
      target="_blank"
      rel="noopener noreferrer"
      className={classnames('external-source-link hyperlink', className)}
    >
      {children ?? t('createTicket')}
    </a>
  );
};

export default SupportTicketLink;
